// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"a10a3f92e9--wrapper--UkJ2d","fullscreen":"a10a3f92e9--fullscreen--MPdYV"};